export const META_PIXEL_ID = '943738095476564'

const SCRIPT_ID = 'meta-pixel-base-code'

/** Código base de Meta Pixel, exactamente como lo entrega Meta. */
const META_PIXEL_SCRIPT = `!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '943738095476564');
fbq('track', 'PageView');`

const META_PIXEL_NOSCRIPT = `<img height="1" width="1" style="display:none"
src="https://www.facebook.com/tr?id=943738095476564&ev=PageView&noscript=1"
/>`

type FbqFunction = (...args: unknown[]) => void

declare global {
  interface Window {
    fbq?: FbqFunction
  }
}

/**
 * Inserta el código base de Meta Pixel al final del <head>, una sola vez por carga de página.
 */
export function installMetaPixel(): void {
  if (typeof document === 'undefined') return
  if (document.getElementById(SCRIPT_ID)) return

  const head = document.head

  head.appendChild(document.createComment(' Meta Pixel Code '))

  const script = document.createElement('script')
  script.id = SCRIPT_ID
  script.text = META_PIXEL_SCRIPT
  head.appendChild(script)

  const noscript = document.createElement('noscript')
  noscript.innerHTML = META_PIXEL_NOSCRIPT
  head.appendChild(noscript)

  head.appendChild(document.createComment(' End Meta Pixel Code '))
}

export function trackPixelEvent(event: string, params?: Record<string, unknown>): void {
  if (typeof window === 'undefined') return
  window.fbq?.('track', event, params)
}
